import { render, staticRenderFns } from "./com-form-map.vue?vue&type=template&id=1bde1244&"
import script from "./com-form-map.vue?vue&type=script&lang=js&"
export * from "./com-form-map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports